import script from "./MoviePlayerVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoviePlayerVideo.vue?vue&type=script&setup=true&lang=ts"

import "./MoviePlayerVideo.vue?vue&type=style&index=0&id=74167eed&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74167eed"]])

export default __exports__